// The portal's one disclosure primitive. P6-83.
//
// 🔴 A REAL <button> WITH A REAL aria-expanded, EVERY TIME. The handoff says it
// in as many words, and it is not a style note: a `<div onClick>` is not
// focusable, not operable from a keyboard, and announces nothing — so the
// "expand" affordance would exist for a mouse and for nobody else. There are
// four of these on this page and they are all this component, which is what
// stops the fourth one being written differently from the first.
//
// 🔴 THE `+` IS aria-hidden AND CARRIES NO INFORMATION. It rotates 45° into an
// `×` when open, which is decoration on top of `aria-expanded` — the state a
// screen reader actually reads, and the state a test asserts. Under
// `prefers-reduced-motion` the CSS drops the transition so it snaps rather than
// animating; nothing here is knowable only by having watched it move.

export default function Disclosure({ open, onToggle, children, className = '', ...rest }) {
  return (
    <button
      type="button"
      className={`d2d-portal__disclosure ${className}`.trim()}
      aria-expanded={open}
      onClick={onToggle}
      {...rest}
    >
      {children}
      <span className="d2d-portal__plus" data-open={open ? 'true' : 'false'} aria-hidden="true">
        +
      </span>
    </button>
  )
}
